import React from 'react';
import TrashIcon from 'assets/icon-trash';
import {
  ClearButton,
  Flex,
  Flex1,
} from 'components/common/styled/common-styled';
import { DiscountCode } from 'types/discount-code';
import { useBrandCurrency } from 'hooks/useBrandCurrency';
import { currencyFormat } from 'utils';
import { DiscountSection, PromoAmount } from './styles';

interface CouponCodeItemProps {
  discountCode: DiscountCode['discountCode'];
  totalCartDiscount: number;
  removeDiscountCode: () => void;
}

const CouponCodeItem = ({
  discountCode,
  totalCartDiscount,
  removeDiscountCode,
}: CouponCodeItemProps) => {
  const currency = useBrandCurrency();

  return (
    <DiscountSection>
      <Flex>
        <Flex1>{discountCode.code}</Flex1>
        <PromoAmount>
          ({currencyFormat(currency)(totalCartDiscount)})
        </PromoAmount>
        <ClearButton
          onClick={removeDiscountCode}
          data-testid="delete-discount-code"
        >
          <TrashIcon />
        </ClearButton>
      </Flex>
    </DiscountSection>
  );
};

export default CouponCodeItem;
